import React from 'react'
import { useHistory } from 'react-router-dom'
import { connect } from 'react-redux'

import { makeStyles, styled, useTheme } from '@material-ui/core/styles'
import Typography from '@material-ui/core/Typography'

import BGnewDiary from '../assets/icons/BGnewReport.png'
import BGnewDiaryOnlyImg from '../assets/icons/BGnewReportOnlyImg.png'
import BGsearchStudentAdmin from '../assets/icons/BGsearchStudentAdmin.svg'

import cardIconTotal from '../assets/icons/cardIconTotal.svg'
import cardIconDone from '../assets/icons/cardIconDone.svg'
import cardIconPending from '../assets/icons/cardIconPending.svg'
import cardIconModerationProf from '../assets/icons/cardIconModeration.svg'
import cardIconModerationAdmin from '../assets/icons/cardIconModerationAdmin.svg'
import cardIconOccurrences from '../assets/icons/cardIconOccurrences.svg'
import noReportSVG from '../assets/icons/no-reportsV2.svg'

import { getReportsCountRSPA, getReports } from '../store/reports/actions'
import CreateReportForm from '../components/form/CreateReportForm'
import SearchReportsForm from '../components/form/SearchReportsForm'
import { roles } from '../utils/constants'
import Button from '../components/button/Button'
import { useMediaQuery } from '@material-ui/core'

const InformationCard = styled('div')(
  ({ theme, bgColor, textColor, isSchoolAdmin }) => ({
    flex: isSchoolAdmin ? '1 1 20%' : '1 1 30%',
    minWidth: 200,
    maxWidth: 400,
    minHeight: 280,
    borderRadius: '16px',
    backgroundColor: bgColor || '#FFFFFF',
    marginBottom: '20px',
    transition: 'all 0.3s ease',
    [theme.breakpoints.down('lg')]: {
      flex: '1 1 20%',
      minWidth: isSchoolAdmin ? 200 : 180
    },
    '&:hover': {
      boxShadow: '0px 10px 18px -3px rgba(0,0,0,0.2)',
      transform: 'translateY(-5px)'
    },

    '& .container': {
      padding: '50px 30px',
      fontFamily: 'Montserrat, Source Sans Pro',
      [theme.breakpoints.down('sm')]: {
        padding: '30px 20px'
      },
      [theme.breakpoints.down('lg')]: {
        padding: '25px 20px'
      },
      '& span': {
        color: textColor || '#4D5E80',
        fontSize: '48px',
        fontWeight: 600,
        lineHeight: '150%',
        letterSpacing: '0%',
        [theme.breakpoints.down('sm')]: {
          fontSize: '32px'
        }
      },

      '& h1': {
        color: textColor || '#4D5E80',
        fontSize: '25px',
        fontWeight: 600,
        marginBottom: 25,
        [theme.breakpoints.down('sm')]: {
          fontSize: '18px'
        },
        [theme.breakpoints.down('lg')]: {
          fontSize: '20px'
        }
      },

      '& p': {
        color: textColor || '#555',
        fontSize: '16px',
        fontWeight: 760,
        lineHeight: '150%',
        letterSpacing: '0%',
        maxWidth: 200,
        margin: 0,
        [theme.breakpoints.down('sm')]: {
          fontSize: '14px'
        }
      }
    }
  })
)

const LargeBanner = styled('div')(
  ({ theme, bgColor, colorButton, colorText }) => ({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    borderRadius: 16,
    gap: 50,
    maxHeight: 277,
    backgroundColor: bgColor || '#FFE9DD',
    marginBottom: 20,
    overflow: 'hidden',
    '& .buttonBannerColor': {
      backgroundColor: colorButton || '#EF7C8F'
    },
    '& .generateReportButtonColor': {
      backgroundColor: '#F4A87C'
    },
    '& .firstBannerSection': {
      margin: '0 0 0 45px',
      fontFamily: 'Montserrat, Source Sans Pro',
      '& h1, & p': {
        fontStyle: 'normal',
        lineHeight: 'normal',
        textAlign: 'left',
        margin: 0,
        [theme.breakpoints.down(1050)]: {
          textAlign: 'center'
        }
      },
      '& h1': {
        fontSize: 24,
        fontWeight: 700,
        marginBottom: 15,
        color: colorText || '#4D5E80'
      },
      '& p': {
        fontSize: 14,
        fontWeight: 400,
        lineHeight: '150%',
        maxWidth: 450,
        color: colorText || '#555'
      },
      [theme.breakpoints.down(1050)]: {
        display: 'flex',
        justifyContent: 'center',
        flexDirection: 'column',
        textAlign: 'center',
        '& .textContent': {
          display: 'flex',
          justifyContent: 'center',
          flexDirection: 'column',
          textAlign: 'center'
        }
      }
    },
    '& .imgBannerLargeOne': {
      width: '55%',
      height: '100%',
      objectFit: 'cover',
      borderRadius: '0 16px 16px 0'
    },
    [theme.breakpoints.down('lg')]: {
      gap: 30,
      '& .firstBannerSection': {
        marginLeft: 30,
        '& h1': { fontSize: 22 },
        '& p': { fontSize: 13 }
      }
    },
    [theme.breakpoints.down('md')]: {
      maxHeight: 277,
      gap: 20,
      '& .firstBannerSection': {
        margin: '20px',
        '& h1': { fontSize: 20 },
        '& p': { maxWidth: '100%' }
      },
      '& .imgBannerLargeOne': {
        width: '43.45%',
        borderRadius: '0 0 16px 16px'
      }
    },
    [theme.breakpoints.down(1050)]: {
      flexDirection: 'column',
      maxHeight: 'none',
      gap: 20,
      '& .firstBannerSection': {
        display: 'flex',
        margin: '20px',
        '& h1': { fontSize: 20 },
        '& p': { maxWidth: '100%' }
      },
      '& .imgBannerLargeOne': {
        width: '100%',
        borderRadius: '0 0 16px 16px'
      }
    },
    [theme.breakpoints.down('sm')]: {
      '& .firstBannerSection': {
        flexDirection: 'column',
        textAlign: 'center',
        '& h1': {
          fontSize: 18
        },
        '& p': {
          fontSize: 12
        }
      }
    }
  })
)

const ContainerCard = styled('div')(({ theme, noScroll, isSchoolAdmin }) => ({
  display: 'flex',
  gap: isSchoolAdmin ? 60 : 20,
  [theme.breakpoints.down('lg')]: {
    gap: 20
  },
  ...(!noScroll && {
    [theme.breakpoints.down('md')]: {
      overflowX: 'auto',
      overflowY: 'visible',
      paddingBottom: 10,
      scrollbarWidth: 'thin',
      scrollbarColor: '#ccc transparent',
      '&::-webkit-scrollbar': {
        height: 8
      },
      '&::-webkit-scrollbar-track': {
        background: 'transparent'
      },
      '&::-webkit-scrollbar-thumb': {
        backgroundColor: '#ccc',
        borderRadius: 4,
        minWidth: 40
      }
    }
  })
}))

const NoReportStyled = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  flexDirection: 'column',
  gap: 16,
  backgroundColor: '#ffffff',
  borderRadius: '0px 0px 8px 8px',
  paddingBottom: '100px',
  paddingTop: '50px',
  '& h5': {
    color: '#386093'
  },
  '& p': {
    fontFamily: 'Montserrat',
    fontWeight: 400,
    fontSize: '16px',
    leadingTrim: 'NONE',
    lineHeight: '150%',
    letterSpacing: '0px',
    textAlign: 'center',
    verticalAlign: 'middle'
  },
  [theme.breakpoints.down('sm')]: {
    '& h5': {
      fontSize: 18
    }
  },
  '& img': {
    objectFit: 'contain',
    width: '100%',
    maxWidth: 450
  }
}))

const useStyles = makeStyles(theme => ({
  root: {
    width: '98%',
    padding: '1rem 0'
  },
  buttons: {
    display: 'flex',
    justifyContent: 'center',
    gap: 16,
    margin: 16,
    [theme.breakpoints.down('426')]: {
      '& button': {
        '& svg': {
          width: '41px !important',
          height: '41px !important',
          minWidth: '41px !important',
          minHeight: '41px !important'
        },
        '& p': {
          fontSize: '12px'
        }
      }
    }
  },
  paper: {
    borderRadius: 8,
    padding: 32,
    [theme.breakpoints.down('426')]: {
      padding: 10
    }
  },
  button_banners: {
    margin: '10px 0 0 0',
    padding: '6px 40px',
    borderRadius: 8,
    fontWeight: 600,
    whiteSpace: 'nowrap',
    [theme.breakpoints.down('1050')]: {
      width: '100%',
      maxWidth: 260,
      margin: '12px auto 0'
    },
    [theme.breakpoints.down('760')]: {
      padding: '6px 34px'
    }
  }
}))

export const NoReportsDiv = () => (
  <NoReportStyled>
    <img src={noReportSVG} alt='imagem da lista de diários vazia' />
    <Typography variant='h5'>Nenhum diário disponível no momento.</Typography>
    <Typography variant='p'>
      Tente aplicar outros filtros para encontrar o que procura.
    </Typography>
  </NoReportStyled>
)

const handleGenerateReport = async (
  reportTemplateId,
  status,
  userId,
  generateReportFunction
) => {
  const data = {
    type: 'reports',
    attributes: {
      report_template_id: reportTemplateId,
      user_id: userId
    }
  }
  generateReportFunction(data)
}

const ReportsPage = ({
  userOccupations,
  getReports,
  getReportsCountRSPA,
  reports,
  schoolId,
  componentAttribute
}) => {
  const history = useHistory()
  const isTeacher = userOccupations?.includes(roles.TEACHER)
  const isSchoolAdmin = userOccupations?.includes(roles.SCHOOL_ADMIN)
  const [reportsCount, setReportsCount] = React.useState({})
  const classes = useStyles({ isTeacher, isSchoolAdmin })
  const theme = useTheme()
  const isMdDown = useMediaQuery(theme.breakpoints.down(1050))
  const defaultParams = {
    'page[size]': 10,
    'q[year_lteq]': new Date().getFullYear() + 1,
    'q[year_gteq]': new Date().getFullYear(),
    'q[classroom_school_id_eq]': schoolId
  }

  const imgSrc = React.useMemo(
    () => {
      if (isMdDown) {
        return BGnewDiaryOnlyImg
      }
      return BGnewDiary
    },
    [isMdDown]
  )

  React.useEffect(() => {
    getReportsCountRSPA().then(res => {
      setReportsCount(res)
    })
  }, [])

  const handleClickGenerateTemplate = () => {
    history.push('reports/create')
  }

  const handleClickStudentDetail = () => {
    history.push('report_student/details')
  }

  if (componentAttribute?.isCreate) {
    return <CreateReportForm />
  }
  return (
    <div className={classes.root}>
      {!isTeacher && (
        <LargeBanner>
          <div className='firstBannerSection'>
            <div className='textContent'>
              <h1>Comece um novo Diário!</h1>
              <p>
                Registre o dia da turma e mantenha os pais informados.
                Personalize e compartilhe facilmente!
              </p>
            </div>
            <Button
              onclick={handleClickGenerateTemplate}
              className={`${classes.button_banners} buttonBannerColor`}
              variant='contained'
            >
              Gerar Diário
            </Button>
          </div>
          <img className='imgBannerLargeOne' src={imgSrc} />
        </LargeBanner>
      )}
      {
        <LargeBanner bgColor='#386093' colorButton='#F4A87C' colorText='#fff'>
          <div className='firstBannerSection'>
            <div className='textContent'>
              <h1>Busca detalhada por aluno</h1>
              <p>
                Encontre todos os registros e detalhes dos diários de turma de
                um aluno específico.
              </p>
            </div>
            <Button
              onclick={handleClickStudentDetail}
              className={`${classes.button_banners} buttonBannerColor`}
              variant='contained'
            >
              Buscar Aluno
            </Button>
          </div>
          <img className='imgBannerLargeOne' src={BGsearchStudentAdmin} />
        </LargeBanner>
      }
      <ContainerCard isSchoolAdmin={isSchoolAdmin}>
        <InformationCard isSchoolAdmin={isSchoolAdmin}>
          <div className='container'>
            <img src={cardIconTotal} />
            <h1>Total Diários</h1>
            <p>Visite todos os diários criados</p>
            <span>{reportsCount?.total || '0000'}</span>
          </div>
        </InformationCard>
        <InformationCard isSchoolAdmin={isSchoolAdmin}>
          <div className='container'>
            <img src={cardIconDone} alt='' />
            <h1>Concluídos</h1>
            <p>Veja os diários que já foram concluídos</p>
            <span>{reportsCount?.done || '0000'}</span>
          </div>
        </InformationCard>
        <InformationCard
          bgColor='#FFE2E6'
          textColor='#EF7C8F'
          isSchoolAdmin={isSchoolAdmin}
        >
          <div className='container'>
            <img src={cardIconPending} />
            <h1>Pendentes</h1>
            <p>Acompanhe os diários pendentes</p>
            <span>{reportsCount?.pending || '0000'}</span>
          </div>
        </InformationCard>
        {isSchoolAdmin && (
          <InformationCard
            bgColor='#FFE9DD'
            textColor='#F4A87C'
            isSchoolAdmin={isSchoolAdmin}
          >
            <div className='container'>
              <img src={cardIconOccurrences} />
              <h1>Ocorrências</h1>
              <p>Acompanhe o total de ocorrências</p>
              <span>{reportsCount?.occurrences || '0000'}</span>
            </div>
          </InformationCard>
        )}
        {(isSchoolAdmin || isTeacher) && (
          <InformationCard
            bgColor={isSchoolAdmin ? '#8B598E' : '#FFE9DD'}
            textColor={isSchoolAdmin ? '#FFFFFF' : '#F4A87C'}
            isSchoolAdmin={isSchoolAdmin}
          >
            <div className='container'>
              <img
                src={
                  isSchoolAdmin
                    ? cardIconModerationAdmin
                    : cardIconModerationProf
                }
              />
              <h1>Moderação</h1>
              {isTeacher && <p>Verifique os diários moderados</p>}
              {isSchoolAdmin && <p>Diários pendentes de moderação</p>}
              <span>{reportsCount?.moderation || '0000'}</span>
            </div>
          </InformationCard>
        )}
        {/* {isTeacher && <MiniRanking data={rows} />} */}
      </ContainerCard>
      {/* {isSchoolAdmin && <ParentsRaking data={rows} />} */}
      <SearchReportsForm
        handleGenerateReport={handleGenerateReport}
        defaultParams={defaultParams}
        reports={reports}
        schoolId={schoolId}
        getReports={getReports}
      />
    </div>
  )
}

const mapStateToProps = ({ auth, reports, school }) => {
  return {
    userOccupations: auth.currentOccupation,
    schoolId: school.currentSchool && school.currentSchool.school_id,
    reports: reports
  }
}

const mapDispatchToProps = dispatch => ({
  getReports: data => dispatch(getReports(data)),
  getReportsCountRSPA: data => dispatch(getReportsCountRSPA.request(data))
})

export default connect(mapStateToProps, mapDispatchToProps)(ReportsPage)
